let excecute = false
const activeTabClassName = "active-tab"
const activeTabClass = "." + activeTabClassName

/**
 * @title Show/Hide Content
 * @description This determines which tabs to show and which to hide based on the navigation
 * @param {string} tabContainer
 */
function showHideContent(tabContainer) {
  const tabContainerName = tabContainer.dataset.tabNavigation
  const activeTab = tabContainer.querySelector(activeTabClass)
  const activeTabName = activeTab.dataset.tab
  const activeContentContainer = document.querySelector('[data-tab-content="' + tabContainerName + '"]')
  const activeContentBlock = activeContentContainer.querySelectorAll('[data-content="' + activeTabName + '"]')

  for (let a = 0; a < activeContentBlock.length; a++) {
    const contentBlocks = activeContentBlock[a].parentElement.children

    for (let i = 0; i < contentBlocks.length; i++) {
      if (contentBlocks[i] === activeContentBlock[a] && contentBlocks[i].hasAttribute("data-content")) {
        contentBlocks[i].classList.add("block")
        contentBlocks[i].classList.remove("hidden")
      } else if (contentBlocks[i] !== activeContentBlock[a] && contentBlocks[i].hasAttribute("data-content")) {
        contentBlocks[i].classList.add("hidden")
        contentBlocks[i].classList.remove("block")
      }
    }
  }
}

/**
 * @title Find Active Content
 * @description This determines which content area is active
 */
function findActiveContent() {
  const tabContainers = document.querySelectorAll("[data-tab-navigation]")

  for (let i = 0; i < tabContainers.length; i++) {
    const activeTabs = tabContainers[i].querySelectorAll("." + activeTabClassName)

    if (!activeTabs.length) {
      tabContainers[i].querySelector("[data-tab]").classList.add(activeTabClassName, "underline")
    }

    showHideContent(tabContainers[i])
  }

  const firstActiveTab = document.querySelector(activeTabClass)
}

/**
 * @title Toggle Active Tab
 * @description This determines which tab is active
 * @param {Element} tab - The tab element
 */
function toggleActiveTab(tab) {
  const navTabs = tab.parentElement.children

  for (let i = 0; i < navTabs.length; i++) {
    if (navTabs[i] !== tab) {
      navTabs[i].classList.remove(activeTabClassName, "underline")
      navTabs[i].setAttribute("aria-selected", "false")
    } else {
      navTabs[i].classList.add(activeTabClassName, "underline")
      navTabs[i].setAttribute("aria-selected", "true")
      scrollTo(navTabs[i])
    }
  }
}

/**
 * @title Hashtag Active
 * @description This determines which element is active
 * @param {string} hash - The ID of the element
 * @param {Element} tab - The tab element
 */
function hashtagActive(hash, tab) {
  hashtagActive = function () {} // Kill it as soon as it was called
  tab = document.querySelector('[data-hash="' + hash + '"]')

  toggleActiveTab(tab)
  findActiveContent()

  excecute = true
}

/**
 * @title Scroll To
 * @description Scroll to the specified element
 * @param {Element} element - The element
 */
function scrollTo(element) {
  const tabCont = element.closest("[data-tab-navigation]")

  if (tabCont.getAttribute("data-orientation") == "horizontal") {
    element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  }
}

/**
 * @title Switch Tab
 * @description Switch the currently active tab
 * @param {Element} tab - The tab element
 */
function switchTab(tab) {
  if (window.location.hash && !excecute) {
    hashtagActive(window.location.hash.replace("#", ""), tab)
  } else {
    toggleActiveTab(tab)
    findActiveContent()
  }
}

/**
 * @title Tab Navigation
 * @description Navigation controller that decides what actions should be taken to control the menu based on input
 */
function tabNavigation() {
  const dataTab = document.querySelector(".tab")
  if (document.body.contains(dataTab)) {
    switchTab(dataTab)

    document.querySelector("body").addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-tab")) {
        switchTab(e.target)
        e.preventDefault()

        if (e.target.dataset.hash) {
          window.history.replaceState(null, null, "#" + e.target.dataset.hash)
        } else {
          window.history.replaceState(null, null, null)
        }
      }
    })
  }
}

export default tabNavigation
